import React from "react";

const PlanCard = ({
    plan,
    selected = false,
    onSelect = () => {},
    selectLabel = "Select",
    selectedLabel = "Selected",
}) => {
    const textMutedColor = plan.isDark ? "rgba(255,255,255,0.75)" : "#475467";
    const features = Array.isArray(plan.features) ? plan.features : [];
    const cardStyle = {
        background: plan.background,
        color: plan.isDark ? "#f8fafc" : "#0f172a",
        border: `2px solid ${selected ? "#4338ca" : "transparent"}`,
        boxShadow: selected ? "0 20px 45px rgba(79,70,229,0.4)" : "0 20px 35px rgba(15,23,42,0.15)",
        cursor: "pointer",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
    };
    const badgeClass = plan.isDark ? "badge bg-white text-primary fw-semibold" : "badge bg-dark text-white fw-semibold";
    const buttonClass = (() => {
        if (selected) {
            return plan.isDark ? "btn btn-light text-primary w-100" : "btn btn-primary w-100";
        }
        return plan.isDark ? "btn btn-outline-light w-100" : "btn btn-outline-primary w-100";
    })();

    return (
        <div className="col-12 col-md-6 col-xl-4">
            <div
                className="rounded-4 p-4 h-100 position-relative plan-card"
                style={cardStyle}
                onClick={onSelect}
                onKeyDown={(evt) => {
                    if (evt.key === "Enter" || evt.key === " ") {
                        evt.preventDefault();
                        onSelect();
                    }
                }}
                role="button"
                tabIndex={0}
                aria-pressed={selected}
            >
                {plan.badge && (
                    <span className={`${badgeClass} position-absolute top-0 end-0 mt-3 me-3 px-3 py-2 rounded-pill`}>
                        {plan.badge}
                    </span>
                )}
                <div className="d-flex align-items-baseline gap-2">
                    <span className="display-5 fw-bold">{plan.price}</span>
                    <span style={{ color: textMutedColor, fontWeight: 600 }}>{plan.period}</span>
                </div>
                <h4
                    className="mt-3 mb-2 fw-semibold"
                    style={{ color: plan.isDark ? "#FFFFFF" : "#0f172a", textShadow: plan.isDark ? "0 2px 6px rgba(0,0,0,0.35)" : "none" }}
                >
                    {plan.name}
                </h4>
                <p className="mb-4" style={{ color: textMutedColor }}>
                    {plan.description}
                </p>
                <ul className="list-unstyled d-flex flex-column gap-2 mb-5">
                    {features.map((feature, index) => (
                        <li key={index} className="d-flex align-items-center gap-2" style={{ color: textMutedColor }}>
                            <span
                                className={`badge rounded-circle ${plan.isDark ? "bg-white text-primary" : "bg-primary-subtle text-primary"}`}
                                style={{ width: 32, height: 32, display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                            >
                                <i className="ti ti-check"></i>
                            </span>
                            <span className="fw-semibold" style={{ color: plan.isDark ? "#ffffff" : "#0f172a" }}>
                                {feature}
                            </span>
                        </li>
                    ))}
                </ul>
                <button
                    type="button"
                    className={buttonClass}
                    onClick={(evt) => {
                        evt.stopPropagation();
                        onSelect();
                    }}
                >
                    {selected ? selectedLabel : selectLabel}
                </button>
            </div>
        </div>
    );
};

export default PlanCard;
